/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface AdminPatchStatusReqBodyDto
 */
export interface AdminPatchStatusReqBodyDto {
    /**
     * 환급 uuid
     * @type {string}
     * @memberof AdminPatchStatusReqBodyDto
     */
    'exchangeUuid': string;
    /**
     * 환급 상태
     * @type {string}
     * @memberof AdminPatchStatusReqBodyDto
     */
    'status': AdminPatchStatusReqBodyDtoStatusEnum;
    /**
     * 기타 환급 불가 사유
     * @type {string}
     * @memberof AdminPatchStatusReqBodyDto
     */
    'exchangeCancelOtherReason'?: string;
    /**
     * 환급 불가 사유 id
     * @type {number}
     * @memberof AdminPatchStatusReqBodyDto
     */
    'exchangeCancelCategoryId'?: number;
}

export const AdminPatchStatusReqBodyDtoStatusEnum = {
    Application: 'application',
    Waiting: 'waiting',
    Completed: 'completed',
    Impossible: 'impossible'
} as const;

export type AdminPatchStatusReqBodyDtoStatusEnum = typeof AdminPatchStatusReqBodyDtoStatusEnum[keyof typeof AdminPatchStatusReqBodyDtoStatusEnum];


